import { LoadablePaint } from '@confluence/loadable';

export const AttachmentsMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AttachmentsMacro" */ '../src/AttachmentsMacroRenderer.tsx'
			)
		).AttachmentsMacroRenderer,
});
